import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Divider} from 'shells/layout/divider';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {SearchResult} from '../search-results/search-result';

import styles from './search-bar-popover.module.css';

type Props = {
    title: string;
    results: Array<any>;
    showSearchAll?: boolean;
    searchAllPath?: string;
};

export const SearchSection = ({title, results, showSearchAll, searchAllPath}: Props) => (
    <div className={styles['search-section']}>
        <div className='px-16'>
            <div className='flex justify-sb full-width align-center'>
                <Body isBold={true} size='small' color='dark'>
                    {title}
                </Body>
                {showSearchAll && searchAllPath && (
                    <Link
                        // @ts-expect-error
                        as={RoutedLink}
                        to={searchAllPath}
                        variant='primary'
                        size='small'
                        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => e.stopPropagation()}
                    >
                        {`Search all ${title.toLowerCase()}`}
                    </Link>
                )}
            </div>
            <Divider variant='line--horizontal' spacing={8} />
        </div>
        <div>
            {results.length > 0 ? (
                results.map((result) => <SearchResult key={result.id} searchResult={result} />)
            ) : (
                <div className='px-16'>
                    <Body size='small' color='dark' isItalic={true}>
                        {`No ${title.toLowerCase()} found`}
                    </Body>
                </div>
            )}
        </div>
    </div>
);
